(function () {
  function cardHTML(item) {
    return (
      '<div class="mini-stars center">★★★★★</div>' +
      '<p>« ' + item.quote + ' »</p>' +
      '<div class="testi-name">' + item.name.toUpperCase() + '</div>'
    );
  }

  function initTestimonialsCarousel(root) {
    var items = Array.prototype.map.call(root.querySelectorAll('.testi-data li'), function (li) {
      return { quote: li.dataset.quote || '', name: li.dataset.name || '' };
    });
    if (!items.length) return;

    var track = root.querySelector('.testi-track');
    var dots = root.querySelector('.dots');
    var slotLeft = track.querySelector('[data-slot="left"]');
    var slotCenter = track.querySelector('[data-slot="center"]');
    var slotRight = track.querySelector('[data-slot="right"]');
    var interval = parseInt(root.dataset.autoplayInterval, 10) || 4500;

    var index = 0;
    var timer = null;

    function render() {
      var len = items.length;
      var left = items[(index - 1 + len) % len];
      var center = items[index];
      var right = items[(index + 1) % len];

      slotLeft.innerHTML = len > 1 ? cardHTML(left) : '';
      slotCenter.innerHTML = cardHTML(center);
      slotRight.innerHTML = len > 1 ? cardHTML(right) : '';

      dots.innerHTML = items
        .map(function (_, i) {
          return (
            '<button type="button" class="dot' +
            (i === index ? ' active' : '') +
            '" data-i="' + i + '" role="tab" aria-selected="' + (i === index) + '" aria-label="Témoignage ' + (i + 1) + '"></button>'
          );
        })
        .join('');

      dots.querySelectorAll('.dot').forEach(function (dot) {
        dot.addEventListener('click', function () {
          index = parseInt(dot.dataset.i, 10);
          render();
          restart();
        });
      });
    }

    function restart() {
      clearInterval(timer);
      if (items.length < 2) return;
      timer = setInterval(function () {
        index = (index + 1) % items.length;
        render();
      }, interval);
    }

    render();
    restart();
  }

  document.querySelectorAll('.testimonials-carousel').forEach(initTestimonialsCarousel);
})();
